module.exports = __webpack_public_path__ + "static/WEDDING E&M-602-65e574dfe034d9311b529a4a9fc8cd4c.jpg";